module.exports = __webpack_public_path__ + "img/mission_intro_bg.68f3a1d5.jpg";